import { Checkbox } from 'antd';
import TablePopover from 'components/tablePopover';
import {  printInfo } from '../../../../../store/forms/utils';
import {
  formattedNumber,
  formattedPercentage,
  filterGakPaidCategory
} from '../../../../../utils/utilsLoans';

export const columnsSelectableExpensesTable = [
  {
    title: 'Κατηγορίες Δαπάνης',
    dataIndex: 'title',
    key: 'title',
    className: 'col-lg',
  },
  {
    title: 'Προϋπολογισμός Αγοράς',
    dataIndex: 'buyBudget',
    key: 'buyBudget',
    className: 'col-2',
  },
  {
    title: 'Προϋπολογισμός Χρήσης',
    dataIndex: 'usageBudget',
    key: 'usageBudget',
    className: 'col-3',
  },
  {
    title: 'Προϋπολογισμός ΕΣ',
    dataIndex: 'esBudget',
    key: 'esBudget',
    className: 'col-3',
  },
  {
    title: 'Επιλέξιμος Προϋπολογισμός ΕΣ',
    dataIndex: 'selectableESBudget',
    key: 'selectableESBudget',
    className: 'col-md',
  },
];

export const columnsLoanCoversTable = [
  {
    title: 'Πυλώνας',
    dataIndex: 'pillar',
    key: 'pillar',
    className: 'col-1',
  },
  {
    title: '% Επενδύσεων Πυλώνα στο ΕΣ',
    dataIndex: 'buyBudget',
    key: 'buyBudget',
    className: 'col-2',
  },
  {
    title: 'Υπάρξη Ελάχιστου Προϋπολογισμού',
    dataIndex: 'usageBudget',
    key: 'usageBudget',
    className: 'col-3',
  },
  {
    title: 'Επιλέξιμο στον Πυλώνα',
    dataIndex: 'esBudget',
    key: 'esBudget',
    className: 'col-3',
  },
  {
    title: '% Δανείο ΤΑΑ',
    dataIndex: 'selectableESBudget',
    key: 'selectableESBudget',
    className: 'col-3',
  },
  {
    title: '% tagging',
    dataIndex: '',
    key: '',
    className: 'col-3',
  },
];

export const columnsGakCumulationTable = [
  {
    title: 'Κατηγορία ενισχύσεων ΓΑΚ',
    dataIndex: 'gakPaidCategory',
    key: 'gakPaidCategory',
    className: 'col-1',
    render: value => filterGakPaidCategory(value),
  },
  {
    title: 'Ενισχυόμενη Επιλέξιμη Δαπάνη',
    dataIndex: 'aidSelectableExpenses',
    key: 'aidSelectableExpenses',
    className: 'col-2',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Μέγιστη Ενίσχυση επιλέξιμης Δαπάνης',
    dataIndex: 'maxEligibleSelectableExpenses',
    key: 'maxEligibleSelectableExpenses',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title:
      'Ενισχύσεις που έχουν ληφθεί για τις ίδιες ενισχυόμενες δαπάνες από άλλες πηγές',
    dataIndex: 'aidReceivedForTheSameExpenseFromOtherSources',
    key: 'aidReceivedForTheSameExpenseFromOtherSources',
    className: 'col-3',
    render: value => (value !== 'hide' ? `${formattedNumber(value)}€` : ' '),
  },
  {
    title: 'Μείωση ενισχύσεων λόγω περιορισμού καθεστώτος (άρθρο 54)',
    dataIndex: 'reductionOfAidDueToRegimeRestriction',
    key: 'reductionOfAidDueToRegimeRestriction',
    className: 'col-3',
    render: value => (value !== ' ' ? `${formattedNumber(value)}€` : ' '),
  },
  {
    title: 'Σωρευόμενη μέγιστη ενίσχυση επιλέξιμων δαπανών ΕΣ',
    dataIndex: 'cumulativeMaxSupport',
    key: 'cumulativeMaxSupport',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
];

export const columnsPillarAGreenTransitionsTable = [
  {
    title: 'Επενδυτική Δαπάνη',
    dataIndex: 'ependytikiDapani',
    key: 'ependytikiDapani',
    className: 'col-1',
    render: value => printInfo(value),
    width: 150
  },
  {
    title: 'Περιγραφή Επενδυτικής Δαπάνης',
    dataIndex: 'perigrafiEpendytikisDapanis',
    key: 'perigrafiEpendytikisDapanis',
    className: 'col-2',
    render: value => printInfo(value),
    width: 500
  },
  {
    title: 'Προϋπολογισμός Αγοράς (€)',
    dataIndex: 'kostosAgoras',
    key: 'kostosAgoras',
    className: 'col-3',
    fixed: 'right',
    align: 'right',
    render: value => `${formattedNumber(value)}€`,
    width: 150
  },
];

export const columnsPillarBDigitalizations = [
  {
    title: 'Επενδυτική Δαπάνη',
    dataIndex: 'investmentExpense',
    key: 'investmentExpense',
    className: 'col-1',
    render: value => printInfo(value),
  },
  {
    title: 'Κατηγορία Ενότητας',
    dataIndex: 'sectionCategory',
    key: 'sectionCategory',
    className: 'col-2',
    render: value => printInfo(value),
  },
  {
    title: 'Κατηγορία Δαπάνης',
    dataIndex: 'expenseCategory',
    key: 'expenseCategory',
    className: 'col-3',
    render: value => printInfo(value),
  },
  {
    title: 'Προϋπολογισμός Αγοράς',
    dataIndex: 'buyBudget',
    key: 'buyBudget',
    className: 'col-4',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Προϋπολογισμός Χρήσης',
    dataIndex: 'usageBudget',
    key: 'usageBudget',
    className: 'col-5',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Πεδίο Παρέμβασης',
    dataIndex: 'interventionField',
    key: 'interventionField',
    className: 'col-6',
    render: value => <TablePopover value={value}></TablePopover>,
  },
  {
    title: 'Δείκτης Αξιολόγησης',
    dataIndex: 'evaluationIndexCoverage',
    key: 'evaluationIndexCoverage',
    className: 'col-5',
    render: value => <TablePopover value={value}></TablePopover>,
  },
  {
    title: '% Συνεισφοράς',
    dataIndex: 'digitalContributionIndicator',
    key: 'digitalContributionIndicator',
    className: 'col-5',
    render: value => (value !== ' ' ? `${formattedPercentage(value)}%` : ''),
  },
  {
    title: 'Προϋπολογισμός Επενδύσεων Ψηφιακού Μετασχηματισμού',
    dataIndex: 'digitalContributionBudget',
    key: 'digitalContributionBudget',
    className: 'col-digi',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Κρατική Ενίσχυση',
    dataIndex: 'gakCategory',
    key: 'gakCategory',
    className: 'col-5',
    render: value => filterGakPaidCategory(value),
  },
];

export const columnsPillarCInnovationsTable = [
  {
    title: 'Επενδυτική Δαπάνη',
    dataIndex: 'investmentExpense',
    key: 'investmentExpense',
    className: 'col-1',
    render: value => printInfo(value),
  },
  {
    title: 'Κατηγορία Ενότητας',
    dataIndex: 'sectionCategory',
    key: 'sectionCategory',
    className: 'col-2',
    render: value => printInfo(value),
  },
  {
    title: 'Κατηγορία Δαπάνης',
    dataIndex: 'expenseCategory',
    key: 'expenseCategory',
    className: 'col-3',
    render: value => printInfo(value),
  },
  {
    title: 'Προϋπολογισμός Αγοράς',
    dataIndex: 'buyBudget',
    key: 'buyBudget',
    className: 'col-4',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Προϋπολογισμός Χρήσης',
    dataIndex: 'usageBudget',
    key: 'usageBudget',
    className: 'col-5',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Προϋπολογισμός Επενδύσεων Καινοτομίας Έρευνας & Ανάπτυξη',
    dataIndex: 'budgetOfInnovationInvestments',
    key: 'budgetOfInnovationInvestments',
    className: 'col-5',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Κρατική Ενίσχυση',
    dataIndex: 'gakCategory',
    key: 'gakCategory',
    className: 'col-5',
    render: value => filterGakPaidCategory(value),
  },
];

export const columnsPillarDMarketGrowth = [
  {
    title: 'Επενδυτική Δαπάνη',
    dataIndex: 'investmentExpense',
    key: 'investmentExpense',
    className: 'col-1',
    render: value => printInfo(value),
  },
  {
    title: 'Κατηγορία Ενότητας',
    dataIndex: 'sectionCategory',
    key: 'sectionCategory',
    className: 'col-2',
    render: value => printInfo(value),
  },
  {
    title: 'Κατηγορία Δαπάνης',
    dataIndex: 'expenseCategory',
    key: 'expenseCategory',
    className: 'col-3',
    render: value => printInfo(value),
  },
  {
    title: 'Προϋπολογισμός Αγοράς',
    dataIndex: 'buyBudget',
    key: 'buyBudget',
    className: 'col-4',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Προϋπολογισμός Χρήσης',
    dataIndex: 'usageBudget',
    key: 'usageBudget',
    className: 'col-5',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Προϋπολογισμός Επενδύσεων Ανάπτυξης Οικονομιών Κλίμακας',
    dataIndex: 'economyDevelopmentInvestmentBudget',
    key: 'economyDevelopmentInvestmentBudget',
    className: 'col-5',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Κρατική Ενίσχυση',
    dataIndex: 'gakCategory',
    key: 'gakCategory',
    className: 'col-5',
    render: value => filterGakPaidCategory(value),
  },
];

export const columnsPillarEExtroversionTable1 = [
  {
    title: 'Εμπορική δραστηριότητα',
    dataIndex: 'title',
    key: 'title',
    className: 'col-1',
  },
  {
    title: 'Έτος Ν-1',
    dataIndex: 'N1',
    key: 'N1',
    className: 'col-2',
  },
  {
    title: 'Έτος Ν-2',
    dataIndex: 'N2',
    key: 'N2',
    className: 'col-3',
  },
  {
    title: 'Έτος Ν-3',
    dataIndex: 'N3',
    key: 'N3',
    className: 'col-3',
  },
  {
    title: 'Μέσος Όρος Τριετίας',
    dataIndex: 'sumRev',
    key: 'sumRev',
    className: 'col-3',
  },
];

export const columnsPillarEExtroversionTable3 = [
  {
    title: 'Εμπορική Δραστηριότητα',
    dataIndex: 'title',
    key: 'title',
    className: 'col-3',
  },
  {
    title: 'Σύνολο',
    dataIndex: 'sum',
    key: 'sum',
    className: 'col-3',
  },
];

export const columnsDeminimis = [
  {
    title: 'Υπολογισμος ενισχυόμενων δαπανών',
    dataIndex: 'sumOfBudget',
    key: 'sumOfBudget',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Μέγιστη ενίσχυση De Minimis',
    dataIndex: 'maxDeminimisFunding',
    key: 'maxDeminimisFunding',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Μέγιστη Ενίσχυση επιλέξιμων Δαπανών',
    dataIndex: 'maxSelectableFundingCompliantToDeminimis',
    key: 'maxSelectableFundingCompliantToDeminimis',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Σύνολο ενισχύσεων της προηγούμενης τριετίας',
    dataIndex: 'totalDeminimisFundingInLast3Years',
    key: 'totalDeminimisFundingInLast3Years',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
  {
    title: 'Τήρηση όρων επιλεξιμότητας De Minimis του Κανονισμού 2013/1407',
    dataIndex: 'deminimisRulesApplied',
    key: 'deminimisRulesApplied',
    className: 'col-3',
    render: value =>
      value ? <Checkbox disabled checked /> : <Checkbox disabled />,
  },
  {
    title: 'Σωρευόμενη Μέγιστη Ενίσχυση Επιλέξιμων Δαπανών ΕΣ',
    dataIndex: 'totalAvailableFundingCompliantToDeminimis',
    key: 'totalAvailableFundingCompliantToDeminimis',
    className: 'col-3',
    render: value => `${formattedNumber(value)}€`,
  },
];
